import React from "react";
import { withRouter } from "react-router-dom";
import ApMobileHeader from "../components/approval/mobile/ApMobileHeader";
import ApMobileBottomPanel from "../components/approval/mobile/ApMobileBottomPanel";
import ApMobileSidebar from "../components/approval/mobile/ApMobileSidebar";
import ApMobileAnnotationsList from "../components/approval/mobile/ApMobileAnnotationsList";
import ApMobileApproveButton from "../components/approval/mobile/ApMobileApproveButton";
import ApMobileAddAnnotationDialog from "../components/approval/mobile/ApMobileAddAnnotationDialog";
import ApMobileDisplay from "../components/approval/mobile/ApMobileDisplay";
import ApMobileZoom from "../components/approval/mobile/ApMobileZoom";
import "../approval.css";

class PageApprovalMobile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentDoc: 0,
      currentPage: 0,
      openedPanel: "",
      addAnnotationMode: false,
      addAnnotationType: "area",
      newAnnotationStep: "type",
      newAnnotationPosition: { x: 0, y: 0 },
      highlightedAnnotation: "",
      displayRotation: 0,
      displayZoom: 1
    };
  }

  onHeaderButton(id) {
    switch (id) {
      case "annotations_panel":
      case "add_annotation_panel":
      case "sidebar":
      case "approve_panel":
      case "reject_panel":
      case "welcome_panel":
        this.openPanel(id);
        break;
      case "add_annotation_dismiss":
        this.openPanel("");
        this.setState({
          addAnnotationMode: false,
          newAnnotationStep: "type"
        });
        break;
    }
  }

  openPanel(id) {
    if (this.state.openedPanel === id) id = "";

    if (id !== "") this.props.history.push("#");
    this.props.history.replace("#" + id);
  }

  componentWillReceiveProps(props, state) {
    const menu = props.location.hash.substr(1);
    this.setState({ openedPanel: menu });
  }

  highlightAnnotation(id) {
    if (this.state.openedPanel !== "annotations_panel")
      this.openPanel("annotations_panel");
    this.setState({ highlightedAnnotation: id });
  }

  selectAddAnnotationType(type) {
    this.openPanel("");
    this.setState({ addAnnotationMode: true, addAnnotationType: type });
  }

  newAnnotationPositionPicked(position) {
    this.openPanel("add_annotation_panel");
    this.setState({
      newAnnotationStep: "message",
      addAnnotationMode: false,
      newAnnotationPosition: position
    });
  }

  addAnnotationMarker(message) {
    const currentDocument = this.props.documents[this.state.currentDoc];

    const newAnnotation = {
      text: message,
      marker: {
        type: this.state.addAnnotationType,
        position: this.state.newAnnotationPosition
      },
      for: {
        document: currentDocument.id,
        page: this.state.currentPage
      }
    };

    this.setState({ newAnnotationStep: "type", addAnnotationMode: false });
    this.props.addAnnotation(newAnnotation);
    this.openPanel("annotations_panel");
  }

  setActiveDocument(docIndex, pageIndex) {
    this.setState({
      currentDoc: docIndex,
      currentPage: pageIndex,
      openedPanel: ""
    });
  }

  render() {
    const {
      openedPanel,
      addAnnotationMode,
      highlightedAnnotation,
      addAnnotationType
    } = this.state;

    const { project, documents, annotations } = this.props;

    const currentPage = this.props.documents[this.state.currentDoc];

    // Disable Pinch Zoom on Safari
    var isSafari = navigator.userAgent.indexOf("Safari") != -1;

    return (
      <div
        className="PageApproval"
        onTouchMove={e => {
          if (isSafari) e.preventDefault();
        }}
      >
        <ApMobileHeader
          onButton={id => this.onHeaderButton(id)}
          addAnnotationType={addAnnotationType}
          addAnnotationMode={addAnnotationMode}
        />

        <ApMobileZoom
          zoom={diff =>
            this.setState({ displayZoom: this.state.displayZoom + diff })
          }
          rotate={() =>
            this.setState({
              displayRotation: this.state.displayRotation + 90
            })
          }
        />

        <ApMobileDisplay
          addAnnotationMode={addAnnotationMode}
          addAnnotationType={addAnnotationType}
          onAddAnnotation={pos => this.newAnnotationPositionPicked(pos)}
          highlightedAnnotation={highlightedAnnotation}
          onHighlightAnnotation={id => this.highlightAnnotation(id)}
          page={currentPage}
          annotations={annotations}
          zoom={this.state.displayZoom}
          rotation={this.state.displayRotation}
        />

        <ApMobileSidebar
          project={project}
          page={currentPage}
          documents={documents}
          selectDocument={(i, p) => this.setActiveDocument(i, p)}
          visible={openedPanel === "sidebar"}
          onClose={() => {
            this.onHeaderButton("sidebar");
          }}
        />

        <ApMobileAddAnnotationDialog
          visible={openedPanel === "add_annotation_panel"}
          mode={this.state.newAnnotationStep}
          onSelectType={type => this.selectAddAnnotationType(type)}
          onAddAnnotation={message => this.addAnnotationMarker(message)}
          onClose={() => this.onHeaderButton("add_annotation_dismiss")}
        />

        <ApMobileBottomPanel
          title="Anmerkungen"
          expandable={true}
          visible={openedPanel === "annotations_panel"}
          onClose={() => this.onHeaderButton("annotations_panel")}
        >
          <ApMobileAnnotationsList
            highlightedAnnotation={highlightedAnnotation}
            onHighlightAnnotation={id => this.highlightAnnotation(id)}
            annotations={annotations}
            page={currentPage}
          />
        </ApMobileBottomPanel>

        <ApMobileBottomPanel
          title="Seite Freigeben"
          visible={openedPanel === "approve_panel"}
          onClose={() => this.onHeaderButton("approve_panel")}
        >
          <ApMobileApproveButton type="approve" fileName="Datei.pdf" />
        </ApMobileBottomPanel>

        <ApMobileBottomPanel
          title="Seite Ablehnen"
          visible={openedPanel === "reject_panel"}
          onClose={() => this.onHeaderButton("reject_panel")}
        >
          <ApMobileApproveButton type="reject" fileName="Datei.pdf" />
        </ApMobileBottomPanel>
        <ApMobileBottomPanel
          title="Herzlich Wilkommen!"
          visible={openedPanel === "welcome_panel"}
          onClose={() => this.onHeaderButton("welcome_panel")}
        >
          <p style={{ padding: 16, color: "#fff", fontSize: 17 }}>
            Wir begrüßen Sie ganz herzlich bei Uelstudios Freeway.
            <br />
            Mit dieser Software haben Sie die Möglichkeit Medien freizugeben
            oder auch abzulehnen. Die Entscheidung liegt bei Ihnen.
            <br />
            Natürlich können Sie jedem Dokument auch zahlreiche Anmerkungen
            hinzufügen.
            <br />
            Sind Sie neu bei Uelstudios Freeway? Dann empfehlen wir Ihnen die
            Tutorial-Tour: <i className="Link">Tutorial</i>
            <br />
            Das Uelstudios-Team wünscht viel Erfolg!
          </p>
        </ApMobileBottomPanel>
      </div>
    );
  }
}

export default withRouter(PageApprovalMobile);



// WEBPACK FOOTER //
// ./src/pages/PageApprovalMobile.js